
// document.addEventListener("DOMContentLoaded", function() {
//   const variantData = document.querySelectorAll(".variant-data .varnt");
//   const flavorSwatches = document.querySelectorAll(".flavour_swatches li, .first_swatch_option");
//   const bagSelect = document.querySelector('select[data-option="Bag"]');
//   const deliverySelect = document.querySelector('select[data-option="Delivery Frequency"]');
//   const addButton = document.querySelector(".custom-add");
//   let selectedFlavor = document.querySelector(".flavour_swatches .active_swatch")?.dataset.name || null;
//   let selectedBag = bagSelect.value;
//   let selectedDelivery = deliverySelect.value;

//   function getVariantId() {
//     const title = `${selectedFlavor} / ${selectedBag} / ${selectedDelivery}`;
//     const variant = Array.from(variantData).find(v => v.dataset.variantTitle === title);
//     // return variant ? variant.dataset.varId : null;
//      return {
//     id: variant.dataset.varId,
//     price: variant.dataset.varnPrice
//   };
//   }

//   function updateVariant() {
//     selectedBag = bagSelect.value;
//     selectedDelivery = deliverySelect.value;
//     const variantId_ob = getVariantId();
//     const variantId = variantId_ob.id;
//     const variantPrice = variantId_ob.price;
//     console.log('getVariantId', variantPrice);
//     console.log("Selected Variant ID:", variantId);

//     if (variantId) {
//       addButton.setAttribute("id", variantId);
//       addButton.setAttribute("data-variant-id", variantId);
//       $(`.variants_selected_data li`).hide()
//       $(`.variants_selected_data li[data-id='${variantId}']`).show()
//       let metadata = $(`.variants_selected_data li[data-id='${variantId}']`).length
//       if(metadata>0){
//         $('.free_gifts_container').show()
//       }else{
//         $('.free_gifts_container').hide()
//       }
//     }
//   }

//   // Flavor click
//   flavorSwatches.forEach(swatch => {
//     swatch.addEventListener("click", function() {
//       selectedFlavor = this.dataset.name;
//       updateVariant();
//     });
//   });

//   // Bag & Delivery select change
//   bagSelect.addEventListener("change", updateVariant);
//   deliverySelect.addEventListener("change", updateVariant);
//   updateVariant();
// });

// document.addEventListener("DOMContentLoaded", function() {
//   const select = document.querySelector('select[data-option="Delivery Frequency"]');
//   const button = document.querySelector('.custom-add.here.me');
//   const hiddenInput = document.querySelector('.sell_opt .selling-update');
//   const sellingPlans = {};
//   document.querySelectorAll('.sell_opt .selling-plan-option label').forEach(label => {
//     const planId = label.getAttribute('data-value').toLowerCase();
//     const text = label.textContent.trim().toLowerCase();
//     sellingPlans[text] = planId;
//   });
//   function updateSellingPlan() {
//     console.log(sellingPlans,'sellingPlans')
//     const selected = select.value.trim().toLowerCase();
//     const planId = sellingPlans[selected] || "";
//     button.setAttribute('data-selling', planId);
//     hiddenInput.value = planId;

//     let selling = JSON.parse($('.selling_plans_json').html());
//     let selling_price_per = selling[0]?.selling_plans?.filter(e=>e.id == planId)
//     let filter_price = selling_price_per[0]?.price_adjustments[0]?.value
//     console.log("Selected Plan:",filter_price, selected, "ID:", planId);
//   }
//   updateSellingPlan();
//   select.addEventListener('change', updateSellingPlan);
// });
document.addEventListener("DOMContentLoaded", () => {

  const variantData = [...document.querySelectorAll(".variant-data .varnt")];
  const flavorSwatches = document.querySelectorAll(".flavour_swatches li, .first_swatch_option");
  const bagSelect = document.querySelector('select[data-option="Bag"]');
  const deliverySelect = document.querySelector('select[data-option="Delivery Frequency"]');
  const addButton = document.querySelector(".custom-add");
  const sellingInput = document.querySelector('.sell_opt .selling-update');
  const selectDelivery = deliverySelect;
  let selectedFlavor = document.querySelector(".flavour_swatches .active_swatch")?.dataset.name || "";
  const sellingPlans = {};
  document.querySelectorAll('.sell_opt .selling-plan-option label').forEach(label => {
    sellingPlans[label.textContent.trim().toLowerCase()] =
      label.getAttribute('data-value').toLowerCase();
  });

  // function getVariant() {
  //   const title = `${selectedFlavor} / ${bagSelect.value} / ${deliverySelect.value}`;
  //   const v = variantData.find(e => e.dataset.variantTitle === title);
  //   return v ? { id: v.dataset.varId, price: v.dataset.varnPrice } : null;
  // }

  function getVariant() {
  let parts = [];
  if (selectedFlavor) parts.push(selectedFlavor);
  if (bagSelect && bagSelect.value) parts.push(bagSelect.value);
  if (deliverySelect && deliverySelect.value) parts.push(deliverySelect.value);
  const title = parts.join(" / ");
  const v = variantData.find(el => el.dataset.variantTitle === title);
  if (!v) {
    console.log("Variant not found for:", title);
    return null;
  }
  return {
    id: v.dataset.varId,
    price: v.dataset.varnPrice
  };
}

  function updateVariant() {
    const variant = getVariant();
    if (!variant) return;
    addButton.dataset.variantId = variant.id;
    addButton.id = variant.id;
    console.log("Variant ID:", variant.id);
    $(".variants_selected_data li").hide();
    const item = $(`.variants_selected_data li[data-id='${variant.id}']`).show();
    $('.free_gifts_container').toggle(item.length > 0);
    updateSellingPlan();
  }

  function updateSellingPlan() {
  const selected = selectDelivery.value.trim().toLowerCase();
  const planId = sellingPlans[selected] || "";
  const variant = getVariant();

  addButton.dataset.selling = planId;
  if (sellingInput) sellingInput.value = planId;

  let selling = JSON.parse($('.selling_plans_json').html());
  let plan = selling?.[0]?.selling_plans?.find(e => e.id == planId);
  let percentage = plan?.price_adjustments?.[0]?.value || 0;

  let price = Number(variant.price);
  let dis = price - (price * percentage / 100);
  let discountPrice = dis.toFixed(2)/100
  // console.log("Original:", price);
  // console.log("Discount %:", percentage);
  let orignalPrice = price / 100;
  console.log(discountPrice+'    '+orignalPrice);
  
  $('span.discount_price.ProductMeta__Price').hide();
  // $('span.product_compare_price').html(' ' + `$${(price/100).toFixed(2)}`);
  // $('span.main_Price').html(' ' + `$${discountPrice.toFixed(2)}`);
  if (discountPrice < orignalPrice) { 
  $('span.product_compare_price').show().html(`$${orignalPrice.toFixed(2)}`);
  $('span.main_Price').html(`$${discountPrice.toFixed(2)}`);
} else { 
  $('span.product_compare_price').hide();
  $('span.main_Price').html(`$${orignalPrice.toFixed(2)}`);
}
}

  flavorSwatches.forEach(swatch => {
    swatch.addEventListener("click", () => {
      selectedFlavor = swatch.dataset.name;
      updateVariant();
    });
  });

  bagSelect.addEventListener("change", updateVariant);
  deliverySelect.addEventListener("change", updateVariant);
  updateVariant();
});

  $('.custom-add').on('click', async function(e) {
    e.preventDefault();
    $(this).addClass('active')
    var variantId  = parseInt($(this).attr('id'));
    let random = Math.floor(Math.random() * 1000);
    var sellingPlan = parseInt($(this).attr('data-selling'));
    var qtyInput = $(this).closest('.product-formMain__option, form').find('input[name="quantity"]');
    var qty = parseInt(qtyInput.val()) || 1;
    var jsonString = $('.free_gifts_json').attr('data-metafield');
    var data = JSON.parse(jsonString);
    var result = data?.variants?.filter(function(e) { return e.id === variantId });
    var gifts = result[0].free_gifts;
    var items = []
    gifts?.forEach(function(giftId) {
      items.push({
        quantity: qty,
        id: giftId.id,
        properties: { __Free_gift: random, Free_gift: 'free' }
      });
    });
    items.push({
      quantity: qty,
      id: variantId,
      selling_plan: sellingPlan,
      properties: { __Free_gift: random }
    });
    console.log("Final Items:", items);
    await window.miniCart.addToCart(items);
    $(this).removeClass('active')
  });

    async function updatequantity(val,qty) {
    try {
        console.log(val,'val')
        // return
      const cart = await window.miniCart.getCart();
      const giftItems = cart.items.filter(item =>
        item.properties && item.properties.__Free_gift  == val
      );
      let updates = {};
      giftItems.forEach(item => {
        updates[item.key] = qty;
      });
      console.log(giftItems,'giftItems')
      if (Object.keys(updates).length === 0) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      console.log('Free gifts removed');
      await window.miniCart.getCart()
      $('.mini-cart__body').removeClass('active')
    if (window.location.pathname === '/cart') {
        window.location.href = '/cart';
    }
    } catch (err) {
      console.error('Error removing gifts:', err);
    }
  }

  async function removeFreeGifts(val) {
    try {
        console.log(val,'val')
      const cart = await window.miniCart.getCart();
      const giftItems = cart.items.filter(item =>
        item.properties && item.properties.__Free_gift  == val
      );
      let updates = {};
      giftItems.forEach(item => {
        updates[item.key] = 0;
      });
      console.log(giftItems,'giftItems')
      if (Object.keys(updates).length === 0) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      console.log('Free gifts removed');
      
      await window.miniCart.getCart()
      $('.mini-cart__body').removeClass('active')
    if (window.location.pathname === '/cart') {
        window.location.href = '/cart';
    }
    } catch (err) {
      console.error('Error removing gifts:', err);
    }
  }

  $(document).on('click', '.Custom_remove_function', async function(e) {
    e.preventDefault();
    let free = parseInt($(this).parents('.cart_qtyPrice__wrapper').attr('data-free-gift'))
    console.log(free,'free')
    await removeFreeGifts(free);
  });
  $(document).on('click', '.custom_remove button.mini-cart__body-line-item-decrease', async function(e) {
    e.preventDefault();
    e.stopPropagation() 
    $('.mini-cart__body').addClass('active') 
    let free = parseInt($(this).attr('data-free-gift'))
    console.log(free,'free')
    await removeFreeGifts(free);
  });
  
  $(document).on('click', '.Custom_add_function', async function(e) {
    e.preventDefault();
    $('.mini-cart__body').addClass('active')
    let free = parseInt($(this).parents('.cart_qtyPrice__wrapper').attr('data-free-gift'))
    let qty = $(this).parents('.qty_wrapper').find('input[name="quantity"]').val()
    console.log(free,'free')
    await updatequantity(free,qty);
  });
  $(document).on('click', '.Mini_Custom_add_function', async function(e) {
    e.preventDefault();
    $('.mini-cart__body').addClass('active')
    let free = parseInt($(this).parents('.maincart_qtyPrice__wrapper').attr('data-free-gift'))
    let qty = parseInt($(this).parents('.maincart_qtyPrice__wrapper').attr('data-qty')) + 1
    console.log(free,'free')
    await updatequantity(free,qty);
  });
  $(document).on('click', '.Mini_Custom_remove_function', async function(e) {
    e.preventDefault();
    $('.mini-cart__body').addClass('active')
    let free = parseInt($(this).parents('.maincart_qtyPrice__wrapper').attr('data-free-gift'))
    let qty = parseInt($(this).parents('.maincart_qtyPrice__wrapper').attr('data-qty')) - 1
    console.log(free,'free')
    await updatequantity(free,qty);
  });

  
  
  $(document).on('click', '.Cart_drawer[data-action="open-drawer"]', async function(e) {
    e.preventDefault();
    window.miniCart.openMiniCart()
  });